// src/components/operation_basic/showConfig.ts
// 统一管理各项配置是否显示的逻辑
import { computed, ref } from 'vue'
import { getCurrentDevice } from '@/profiles/selector'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { DeviceManager } from '@/service/device'

import { OperateType } from '@/service/driver/operate'

// 需要异步判断的配置
export const isShowRate = ref(false)

export const isShowDpi = computed(() => getCurrentDevice.value.dpi?.list?.length > 0)
export const isShowLockWin = computed(() => getCurrentDevice.value.lockWin)
export const isShowSuperResponse = computed(() => getCurrentDevice.value.superResponse)
export const isShowSleepTime = computed(() => getCurrentDevice.value.sleepTimeValues?.length > 0)
export const isShowBTSleepTime = computed(() => getCurrentDevice.value.sleepTimeBTValues?.length > 0)
export const isShowRTStab = computed(() => getCurrentDevice.value.adjustRTStabilization?.length > 0)
export const isShowTouchGuard = computed(() => getCurrentDevice.value.touchGuard)
export const isShowKeyboardDebounce = computed(() => getCurrentDevice.value.keyboardDebounce?.length > 0)
export const isShowStabilityTime = computed(() => specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMagnet))

// 可以设置读取winlock状态的设备
export const isShowWinLock = computed(() => specialCheckCurrent(speciaBehiver.SupportWinLock))
export const isShowKeyMode = computed(() => specialCheckCurrent(speciaBehiver.SupportKeyMode))
// export const isShowLockKeyboard = computed(() => specialCheckCurrent(speciaBehiver.SupportLockKeyboardDevice))
// export const isShowDirectionKeySwap = computed(() => specialCheckCurrent(speciaBehiver.SupportDirectionKeySwapDevice))

export const shouldMoveRtToLeft = computed(() => {
  return !(isShowSleepTime.value && isShowBTSleepTime.value) && specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)
})

export const isShowLeftConfigMgx = computed(() => {
  return DeviceManager.instance.state.currentDevice.IsSupportMagnet
})

export const isShowLeftConfigBaseSet = computed(() => {
  return (
    isShowDpi.value ||
    isShowLockWin.value ||
    isShowRate.value ||
    isShowSuperResponse.value ||
    isShowSleepTime.value ||
    isShowRTStab.value ||
    isShowTouchGuard.value ||
    isShowBTSleepTime.value ||
    isShowKeyboardDebounce.value ||
    isShowKeyMode.value ||
    isShowWinLock.value
  )
})

const hasLeftContent = computed(() => {
  return (
    isShowKeyboardDebounce.value ||
    isShowDpi.value ||
    isShowTouchGuard.value ||
    (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan) && (isShowSleepTime.value || isShowBTSleepTime.value)) ||
    (shouldMoveRtToLeft.value && isShowRTStab.value) ||
    isShowStabilityTime.value
  )
})
const hasRightContent = computed(() => {
  return isShowLockWin.value || isShowRate.value || isShowSuperResponse.value || (!shouldMoveRtToLeft.value && isShowRTStab.value) || (!specialCheckCurrent(speciaBehiver.DeviceOfRoyuan) && isShowSleepTime.value)
})
export const isShowBaseViewLine = computed(() => hasLeftContent.value && hasRightContent.value)

export const mouseOperationsSort = [OperateType.base, OperateType.advanced, OperateType.action, OperateType.light]
